import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 21h12V7H6v14zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DeleteSharp.js
// module id = 3081
// module chunks = 2